import { ApiStatus } from 'common/enums';
import { UserState } from '../../models';

const initialUserState: UserState = {
    name: '',
    emailId: '',
    id: '',
    avatar: '',
    profileApiStatus: ApiStatus.NONE,
    userInfo: {}
};

export default initialUserState;
